var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyDark = function SvgEmptyDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 124,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#474E5A",
    d: "M80.436 123.501c-.016-.068-1.506-6.863 1.537-12.507s9.54-8.133 9.606-8.158l.297-.111.07.309c.015.068 1.505 6.864-1.538 12.508s-9.54 8.133-9.605 8.157l-.297.112zm11.032-20.021c-1.3.56-6.437 3.009-9.007 7.776-2.57 4.768-1.795 10.405-1.548 11.799 1.3-.558 6.435-3.004 9.008-7.776 2.57-4.767 1.795-10.404 1.547-11.799"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474E5A",
    d: "M88.083 113.562c-5.47 3.29-7.576 9.826-7.576 9.826s6.761 1.201 12.23-2.089 7.576-9.827 7.576-9.827-6.76-1.201-12.23 2.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DA8EC",
    d: "M73.234 71.965h15.452v-7.822H73.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C7C1",
    d: "M76.464 64.918a2.196 2.196 0 0 0-2.3-2.46l-2.174-4.525-3.072.65 3.16 6.347a2.208 2.208 0 0 0 4.385-.012M29.275 117.452l2.556 1.309 6.264-9.239-3.774-1.931z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191E24",
    d: "m29.05 116.284 5.035 2.577a3.6 3.6 0 0 1 1.567 4.85l-.053.105-8.244-4.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C7C1",
    d: "M58.803 121.032h2.872l1.366-11.078h-4.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191E24",
    d: "M58.068 120.094h5.656a3.604 3.604 0 0 1 3.605 3.604v.117l-9.26.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59606E",
    d: "M45.368 30.673s-1.924-1.474-1.924 2.126l-.303 11.893 3.39 11.236 1.974-3.644-.81-7.895z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191E24",
    d: "M65.94 63.204s2.23 10.861-.594 19.775l-1.561 34.27-5.725-.446-2.007-25.424-1.933-12.638-4.014 11.523-13.232 24.383-6.096-4.757s6.755-18.432 11.745-22.302l2.503-28.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C7C1",
    d: "M59.157 16.152a6.527 6.527 0 1 0 0-13.054 6.527 6.527 0 0 0 0 13.054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191E24",
    d: "M58.694 11.01c.782.101 1.372-.7 1.646-1.44s.482-1.6 1.162-2c.93-.547 2.119.11 3.181-.07 1.2-.204 1.981-1.476 2.042-2.691.061-1.216-.422-2.385-.897-3.506l-.166 1.393A2.76 2.76 0 0 0 64.455.28l.213 2.044A2.17 2.17 0 0 0 62.172.53l.034 1.218c-1.386-.165-2.784-.33-4.175-.204-1.39.125-2.79.565-3.844 1.48-1.576 1.37-2.152 3.626-1.958 5.705.193 2.079 1.051 4.032 1.946 5.92.225.474.536 1.01 1.058 1.07a1.066 1.066 0 0 0 1.044-.787c.112-.46.108-.942-.013-1.4-.132-.701-.298-1.417-.174-2.12.124-.702.63-1.396 1.337-1.482.708-.086 1.432.723 1.092 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AEBC",
    d: "M66.345 66.109 44.56 64.703l1.64-6.793 19.912 4.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59606E",
    d: "m52.91 18.526 1.366-1.897s1.527.519 5.618 2.555l.289 1.777 7.1 43.672-12.906-.557-3.514-.074-1.15-2.578-1.419 2.523-3.432-.073-3.492-2.025 3.442-10.527 1.113-9.616-1.72-9.06s-2.166-8.318 6.174-12.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AEBC",
    d: "m70.796 62.595.469 1.64 3.28-2.136-1.238-1.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59606E",
    d: "M55.35 23.804s5.084-6.49 8.157.744l.969 7.58s3.722 9.423 3.834 13.236c0 0 2.524 4.975 2.5 7.589l3.734 8.452-3.83 2.377-10.597-16.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52575E",
    d: "M105.729 124H.277a.276.276 0 1 1 0-.554h105.452a.278.278 0 0 1 0 .554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D434E",
    d: "M96.893 61.008h119.955V.28H96.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474E5A",
    d: "M217.838 61.997H95.904V-.708h121.934zM97.883 60.018H215.86V1.271H97.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59606E",
    d: "M192.837 11.34h-22.601v38.61h22.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DA8EC",
    d: "M166.492 11.34h-45.586v10.627h45.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59606E",
    d: "M166.492 24.927h-45.586V36.36h45.586zM166.492 39.32h-45.586v10.628h45.586z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h218v124H0z"
  })))));
};
export default SvgEmptyDark;